import React from "react";

function Footer() {
  return (
    <footer>
      <div>
        <span>Holidaze</span> Est. in 2022 - Lars Walderhaug
      </div>
    </footer>
  );
}

export default Footer;
